<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-19 10:15:07
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-25 17:07:21
 * @Description: file content
 -->
<template>
  <div class="btn_home" v-if="isShow">
    <img @click="clickHome" :src="btnImgUrl" alt />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import wxsdk from "@/utils/wxsdk";
import util from "@/utils/utils";
export default {
  components: {},
  props: {},
  data() {
    return {
      isShow: false,
      btnImgUrl:
        "https://assets.rurushishi.com/yq-rs-make/components/btn_home/home.png?x-oss-process=image/resize,h_100,w_100"
    };
  },
  watch: {},
  computed: {
    ...mapState(["isInMiniProgram", "receiveSpreadInfo"])
  },
  methods: {
    clickHome() {
      if (this.$route.query.entry == "zxslzx") {
        if (this.$route.query.orgfrom) {
          let url = `${location.protocol}//${location.host}/h5/${this.$route.query.orgfrom}?id=${this.$pageid}&psn=${this.$psn}`;
          if (
            this.$route.query.orgfrom == "t7" &&
            this.$route.query.t9id &&
            this.$route.query.t9psn
          ) {
            url += `&entry=zxslzx&t9id=${this.$route.query.t9id}&t9psn=${this.$route.query.t9psn}`;
          }
          if (this.receiveSpreadInfo.refereeopenid) {
            url += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
          }
          if (this.receiveSpreadInfo.rscuid) {
            url += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
          }
          util.openUrl(url);
        } else {
          let url = `${location.protocol}//${location.host}/h5/t9?id=${this.$route.query.t9id}&psn=${this.$route.query.t9psn}`;
          if (this.receiveSpreadInfo.refereeopenid) {
            url += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
          }
          if (this.receiveSpreadInfo.rscuid) {
            url += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
          }
          if (this.$route.query.topfrom) {
            url = url.replace("/t9", this.$route.query.topfrom);
          }
          util.openUrl(url, "reLaunch");
        }
      } else if (this.global.SUBDOMAIN == "henduoke") {
        wxsdk.wx.miniProgram.switchTab({
          url: `/pages/hdk/intro/intro`
        });
      } else if (this.global.SUBDOMAIN == "wdzyt") {
        util.openUrl(
          `${location.protocol}//${location.host}/marketies/rsrc/wdzyt/index`
        );
      } else if (this.$route.query.from == "t9") {
        // this.$router.back(-1);
        window.history.go(-1);
      }
    }
  },
  created() {
    if (this.$route.query.entry == "zxslzx") {
      this.btnImgUrl =
        "https://assets.rurushishi.com/yq-rs-make/components/btn_home/home2.png?x-oss-process=image/resize,h_100,w_100";
      this.isShow = true;
    } else if (this.global.SUBDOMAIN == "henduoke") {
      if (this.isInMiniProgram) {
        this.isShow = true;
      }
    } else if (this.global.SUBDOMAIN == "wdzyt") {
      this.isShow = true;
    } else if (this.$route.query.from == "t9") {
      this.btnImgUrl =
        "https://assets.rurushishi.com/yq-rs-make/components/btn_home/home2.png?x-oss-process=image/resize,h_100,w_100";
      this.isShow = true;
    }
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.btn_home img {
  width: 60px;
  height: 60px;
  position: fixed;
  right: 10px;
  bottom: 200px;
  opacity: 0.8;
  z-index: 10;
}
</style>